import React from "react";
import { Images } from "../Images/Index";
import { useNavigate } from "react-router-dom";
import "../App.css"; 

function SigninBase() {
  const navigate = useNavigate();

  const logout = () => {
    const accessType = sessionStorage.getItem("AccessType");
    if (accessType === "jobseeker") {
      navigate("/Jobseekerdashboard");
    } else if (accessType === "Employer") {
      navigate("/Employerdashboard");
    } else {
      navigate("/");
    }
  };

  return (
    <div className="header fixed-top d-flex align-items-center justify-content-between px-3">
      {/* Logo Section */}
      <div className="d-flex align-items-center">
        <a className="logo d-flex align-items-center">
          <img
            src={Images.mainlogo}
            alt="Pelago"
            className="userlg_img"
            style={{ maxWidth: "150px", height: "auto" }} // Ensure it scales properly
          />
        </a>
      </div>

      {/* Navigation */}
      <nav className="header-nav ms-auto">
        <ul className="d-flex align-items-center mb-0">
          <li className="nav-item dropdown pe-3">
            <i
              className="bi bi-house"
              onClick={logout}
              style={{ fontSize: "25px", color: "blue", cursor: "pointer" }}
            ></i>
          </li>
        </ul>
      </nav>
    </div>
  );
}

export default SigninBase;
